export default __webpack_public_path__ + "static/ignite-bd52d233cbaad2267b9d530b62fd04ee.png";